export const skipToContentAccessibility = (event: FocusEvent) => {
  let logoFocusIndex = 0;
  let logoElem: HTMLElement | null = null;

  const udexShell = document.querySelector('udex-masthead-shell');
  if (udexShell && udexShell.shadowRoot) {
    logoElem = udexShell.shadowRoot.querySelector('[title="SAP"]');
  }

  if (!logoElem) {
    console.warn('SAP Logo element not found.');
    return;
  }

  const parentElem = logoElem?.parentElement;
  parentElem.setAttribute('tabindex', '-1');

  const contentSkipElement = document.createElement('div');
  contentSkipElement.setAttribute('aria-label', 'Skip to content');
  contentSkipElement.style.margin = '5px';
  contentSkipElement.style.color = 'blue';
  contentSkipElement.style.fontSize = '16px';
  contentSkipElement.style.cursor = 'pointer';
  contentSkipElement.textContent = 'Skip to content';

  const groupSkipElem: HTMLElement = document.querySelector('[libGroupSkip]');

  if (isHeaderFocusedButClicked(event)) {
    logoElem.addEventListener('click', () => {
      const url = logoElem.getAttribute('href');
      window.location.replace(url);
    });
  } else if (isHeaderFocusedOutThenIn(event)) {
    const udexAvatarIcon: HTMLElement = document.querySelector('udex-avatar');
    if (udexAvatarIcon) udexAvatarIcon.focus();
  } else {
    parentElem.addEventListener(
      'focus',
      () => {
        parentElem.replaceChild(contentSkipElement, logoElem);
        parentElem.addEventListener(
          'blur',
          () => {
            parentElem.replaceChild(logoElem, contentSkipElement);
            if (logoFocusIndex !== 0) {
              logoElem.focus();
            }
            logoFocusIndex++;
          },
          {once: true}
        );
        parentElem.addEventListener(
          'click',
          () => {
            focusGroup(groupSkipElem);
          },
          {once: true}
        );
        parentElem.addEventListener(
          'keypress',
          (event) => {
            if (event.key === 'Enter') {
              focusGroup(groupSkipElem);
            }
          },
          {once: true}
        );
      },
      {once: true}
    );

    parentElem.focus();
  }
};

function isHeaderFocusedButClicked(event: FocusEvent): boolean {
  return (event.relatedTarget as HTMLElement)?.offsetParent?.classList.contains('header-navigation-wrapper');
}

function isHeaderFocusedOutThenIn(event: FocusEvent): boolean {
  return (event.relatedTarget as HTMLElement)?.localName === 'udex-link';
}

function focusGroup(element: HTMLElement): void {
  if (element.nodeName === 'UDEX-TILE') {
    element.shadowRoot.querySelector('a').focus();
  } else {
    element.focus();
  }
}
